var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFourZeroFour = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 54,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.6.25C2.98.25 0 3.277 0 6.953v31.281c0 3.676 2.98 6.703 6.6 6.703h24.174c-.001.72-.003 1.461 0 2.287.004 1.096.003 1.357.009 2.182H17.6v4.469h30.8v-4.469H35.183c-.006-.826-.005-1.096-.009-2.2-.003-.822-.001-1.556 0-2.269H59.4c3.62 0 6.6-3.027 6.6-6.703V6.954C66 3.276 63.02.25 59.4.25H6.6Zm0 4.469h52.8c1.239 0 2.2.976 2.2 2.234v31.281c0 1.258-.962 2.235-2.2 2.235H6.6c-1.238 0-2.2-.977-2.2-2.235V6.954c0-1.259.962-2.235 2.2-2.235Zm24.2 4.468v17.876h4.4V9.188h-4.4Zm0 22.344V36h4.4v-4.469h-4.4Z",
  fill: "#111",
  fillOpacity: 0.48
})));
export default SvgFourZeroFour;